
import dashboardRequest from '@/pages/dashboard/utils/dashboardRequest';
import { setCustomFilterList } from '../components/NewFilter/customFilterList';
export const getSelectorList: (data: any) => Promise<any> = (data) => {
  const options = {
    url: '/api/v1/dashboard/funnel_analysis/selector',
    method: 'post',
    data,
  };
  return dashboardRequest(options);
};

export const getFunnelDailySelectorList: (data: any) => Promise<any> = (data) => {
  const options = {
    url: '/api/v1/dashboard/pc/customized/selector',
    method: 'post',
    data,
    formatData: (data: any): any => {
      const {custom_filters: customFilters, ...otherData} = data || {};
      // 自定义筛选器列表
      const customFiltersKey = Object.keys(customFilters || {});
      setCustomFilterList(customFiltersKey, true);
      return {...(otherData || {}), ...(customFilters || {})};
    }
  };
  return dashboardRequest(options);
};

//  获取 Performance 宽表数据
export const getFunnelPerformanceTable: (data: any, language: string, pageType: string) => Promise<any> = (data, language, pageType) => {
  const options = {
    url: `/api/v1/dashboard/funnel_analysis/register/${pageType === 'mobile' ? '' : (`${pageType  }/`)}overall_performance?language=${language}`,
    method: 'post',
    data,
  };
  return dashboardRequest(options);
};

// Performance 宽表下载
export const downLoadFunnelPerformanceTable: (data: any, language: string, pageType: string) => Promise<any> = (data, language, pageType) => {
  const options = {
    url: `/api/v1/dashboard/funnel_analysis/register/${pageType === 'mobile' ? '' : (`${pageType  }/`)}overall_performance/download?language=${language}`,
    method: 'post',
    data,
    rawData: true,
    responseType: 'arraybuffer',
  };
  return dashboardRequest(options);
};

// 卡片
export const getFunnelStep: (data: any, pageType: string) => Promise<any> = (data, pageType) => {
  const options = {
    url: `/api/v1/dashboard/funnel_analysis/register/${pageType === 'mobile' ? '' : (`${pageType  }/`)}device_conversion`,
    method: 'post',
    data,
  };
  return dashboardRequest(options);
};

// Tends
export const getFunnelTends: (data: any, pageType: string) => Promise<any> = (data, pageType) => {
  const options = {
    url: `/api/v1/dashboard/funnel_analysis/register/${pageType === 'mobile' ? '' : (`${pageType  }/`)}trends`,
    method: 'post',
    data,
  };
  return dashboardRequest(options);
};

// Trends by step
export const getFunnelTendsStep: (data: any, pageType: string) => Promise<any> = (data, pageType) => {
  const options = {
    url: `/api/v1/dashboard/funnel_analysis/register/${pageType === 'mobile' ? '' : (`${pageType  }/`)}trends_by_step`,
    method: 'post',
    data,
  };
  return dashboardRequest(options);
};

// Tends
export const getRegisterFunnelTends: (data: any, pageType: string) => Promise<any> = (data, pageType) => {
  const options = {
    url: `/api/v1/dashboard/funnel_analysis/register/${pageType === 'mobile' ? '' : (`${pageType  }/`)}funnle`,
    method: 'post',
    data,
  };
  return dashboardRequest(options);
};


